import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, withModifiers as _withModifiers, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Teleport as _Teleport, createBlock as _createBlock } from "vue"

import { ref, onMounted, onUnmounted } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'PhoneContextMenu',
  emits: ['restart', 'reset', 'oneKeyNew', 'changeModel', 'transfer'],
  setup(__props, { expose: __expose, emit: __emit }) {

const visible = ref(false);
const x = ref(0);
const y = ref(0);
const phoneId = ref('');
const client = ref<any>(null);

const emit = __emit;

const show = (event: MouseEvent, id: string, clientInstance: any) => {
  x.value = event.clientX;
  y.value = event.clientY;
  phoneId.value = id;
  client.value = clientInstance;
  visible.value = true;
};

const hide = () => {
  visible.value = false;
};

const handleRestart = () => {
  emit('restart', phoneId.value, client.value);
  hide();
};

const handleReset = () => {
  emit('reset', phoneId.value, client.value);
  hide();
};

const handleOneKeyNew = () => {
  emit('oneKeyNew', phoneId.value, client.value);
  hide();
};

const handleChangeModel = () => {
  emit('changeModel', phoneId.value, client.value);
  hide();
};

const handleTransfer = () => {
  emit('transfer', phoneId.value, client.value);
  hide();
};

const handleClickOutside = () => {
  hide();
};

onMounted(() => {
  document.addEventListener('click', handleClickOutside);
});

onUnmounted(() => {
  document.removeEventListener('click', handleClickOutside);
});

__expose({ show, hide });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    (visible.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "context-menu",
          style: _normalizeStyle({ left: x.value + 'px', top: y.value + 'px' }),
          onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"]))
        }, [
          _createElementVNode("div", {
            class: "menu-item",
            onClick: handleRestart
          }, [...(_cache[1] || (_cache[1] = [
            _createElementVNode("span", null, "重启云机", -1)
          ]))]),
          _createElementVNode("div", {
            class: "menu-item",
            onClick: handleReset
          }, [...(_cache[2] || (_cache[2] = [
            _createElementVNode("span", null, "重置云机", -1)
          ]))]),
          _createElementVNode("div", {
            class: "menu-item",
            onClick: handleOneKeyNew
          }, [...(_cache[3] || (_cache[3] = [
            _createElementVNode("span", null, "一键新机", -1)
          ]))]),
          _createElementVNode("div", {
            class: "menu-item",
            onClick: handleChangeModel
          }, [...(_cache[4] || (_cache[4] = [
            _createElementVNode("span", null, "更换机型", -1)
          ]))]),
          _createElementVNode("div", {
            class: "menu-item",
            onClick: handleTransfer
          }, [...(_cache[5] || (_cache[5] = [
            _createElementVNode("span", null, "转移云机", -1)
          ]))])
        ], 4))
      : _createCommentVNode("", true)
  ]))
}
}

})